'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var nationalityLabels = (0, _reactIntl.defineMessages)({
    1: {
        'id': 'formOptions.nationalityLabels.1',
        'defaultMessage': 'Afghanistan'
    },
    2: {
        'id': 'formOptions.nationalityLabels.2',
        'defaultMessage': 'Albanian'
    },
    3: {
        'id': 'formOptions.nationalityLabels.3',
        'defaultMessage': 'Algerian'
    },
    4: {
        'id': 'formOptions.nationalityLabels.4',
        'defaultMessage': 'American Samoan'
    },
    5: {
        'id': 'formOptions.nationalityLabels.5',
        'defaultMessage': 'Andorran'
    },
    6: {
        'id': 'formOptions.nationalityLabels.6',
        'defaultMessage': 'Angolan'
    },
    7: {
        'id': 'formOptions.nationalityLabels.7',
        'defaultMessage': 'Anguillan'
    },
    8: {
        'id': 'formOptions.nationalityLabels.8',
        'defaultMessage': 'Antigua and Barbuda'
    },
    9: {
        'id': 'formOptions.nationalityLabels.9',
        'defaultMessage': 'Argentinian'
    },
    10: {
        'id': 'formOptions.nationalityLabels.10',
        'defaultMessage': 'Armenian'
    },
    11: {
        'id': 'formOptions.nationalityLabels.11',
        'defaultMessage': 'Aruban'
    },
    12: {
        'id': 'formOptions.nationalityLabels.12',
        'defaultMessage': 'Australian'
    },
    13: {
        'id': 'formOptions.nationalityLabels.13',
        'defaultMessage': 'Austrian'
    },
    14: {
        'id': 'formOptions.nationalityLabels.14',
        'defaultMessage': 'Azerbaijani'
    },
    15: {
        'id': 'formOptions.nationalityLabels.15',
        'defaultMessage': 'Bahamian'
    },
    16: {
        'id': 'formOptions.nationalityLabels.16',
        'defaultMessage': 'Bahranian'
    },
    17: {
        'id': 'formOptions.nationalityLabels.17',
        'defaultMessage': 'Bangladeshi'
    },
    18: {
        'id': 'formOptions.nationalityLabels.18',
        'defaultMessage': 'Barbadian'
    },
    19: {
        'id': 'formOptions.nationalityLabels.19',
        'defaultMessage': 'Belarus'
    },
    20: {
        'id': 'formOptions.nationalityLabels.20',
        'defaultMessage': 'Belgian'
    },
    21: {
        'id': 'formOptions.nationalityLabels.21',
        'defaultMessage': 'Belizean'
    },
    22: {
        'id': 'formOptions.nationalityLabels.22',
        'defaultMessage': 'Beninese'
    },
    23: {
        'id': 'formOptions.nationalityLabels.23',
        'defaultMessage': 'Bermuda'
    },
    24: {
        'id': 'formOptions.nationalityLabels.24',
        'defaultMessage': 'Bhutanese'
    },
    25: {
        'id': 'formOptions.nationalityLabels.25',
        'defaultMessage': 'Bolivian'
    },
    26: {
        'id': 'formOptions.nationalityLabels.26',
        'defaultMessage': 'Bonaire'
    },
    27: {
        'id': 'formOptions.nationalityLabels.27',
        'defaultMessage': 'Bosnian'
    },
    28: {
        'id': 'formOptions.nationalityLabels.28',
        'defaultMessage': 'Botswanan'
    },
    29: {
        'id': 'formOptions.nationalityLabels.29',
        'defaultMessage': 'Bouvet Island'
    },
    30: {
        'id': 'formOptions.nationalityLabels.30',
        'defaultMessage': 'Brazilian'
    },
    31: {
        'id': 'formOptions.nationalityLabels.31',
        'defaultMessage': 'British'
    },
    32: {
        'id': 'formOptions.nationalityLabels.32',
        'defaultMessage': 'British Virgin Islands'
    },
    33: {
        'id': 'formOptions.nationalityLabels.33',
        'defaultMessage': 'Brunei'
    },
    34: {
        'id': 'formOptions.nationalityLabels.34',
        'defaultMessage': 'Bulgarian'
    },
    35: {
        'id': 'formOptions.nationalityLabels.35',
        'defaultMessage': 'Burkina Faso'
    },
    36: {
        'id': 'formOptions.nationalityLabels.36',
        'defaultMessage': 'Burmese'
    },
    37: {
        'id': 'formOptions.nationalityLabels.37',
        'defaultMessage': 'Burundi'
    },
    38: {
        'id': 'formOptions.nationalityLabels.38',
        'defaultMessage': 'Cambodian'
    },
    39: {
        'id': 'formOptions.nationalityLabels.39',
        'defaultMessage': 'Cameroon'
    },
    40: {
        'id': 'formOptions.nationalityLabels.40',
        'defaultMessage': 'Canadian'
    },
    41: {
        'id': 'formOptions.nationalityLabels.41',
        'defaultMessage': 'Cape Verde Islands'
    },
    42: {
        'id': 'formOptions.nationalityLabels.42',
        'defaultMessage': 'Cayman Islands'
    },
    43: {
        'id': 'formOptions.nationalityLabels.43',
        'defaultMessage': 'Central African'
    },
    44: {
        'id': 'formOptions.nationalityLabels.44',
        'defaultMessage': 'Chad'
    },
    45: {
        'id': 'formOptions.nationalityLabels.45',
        'defaultMessage': 'Chilean'
    },
    46: {
        'id': 'formOptions.nationalityLabels.46',
        'defaultMessage': 'Chinese'
    },
    47: {
        'id': 'formOptions.nationalityLabels.47',
        'defaultMessage': 'Christmas Island'
    },
    48: {
        'id': 'formOptions.nationalityLabels.48',
        'defaultMessage': 'Clipperton Island'
    },
    49: {
        'id': 'formOptions.nationalityLabels.49',
        'defaultMessage': 'Cocos Islands'
    },
    50: {
        'id': 'formOptions.nationalityLabels.50',
        'defaultMessage': 'Colombian'
    },
    51: {
        'id': 'formOptions.nationalityLabels.51',
        'defaultMessage': 'Comoros'
    },
    52: {
        'id': 'formOptions.nationalityLabels.52',
        'defaultMessage': 'Congo'
    },
    53: {
        'id': 'formOptions.nationalityLabels.53',
        'defaultMessage': 'Cook Islands'
    },
    54: {
        'id': 'formOptions.nationalityLabels.54',
        'defaultMessage': 'Costa Rican'
    },
    55: {
        'id': 'formOptions.nationalityLabels.55',
        'defaultMessage': 'Croatian'
    },
    56: {
        'id': 'formOptions.nationalityLabels.56',
        'defaultMessage': 'Cuban'
    },
    57: {
        'id': 'formOptions.nationalityLabels.57',
        'defaultMessage': 'Curacao'
    },
    58: {
        'id': 'formOptions.nationalityLabels.58',
        'defaultMessage': 'Cyprus'
    },
    59: {
        'id': 'formOptions.nationalityLabels.59',
        'defaultMessage': 'Czech'
    },
    60: {
        'id': 'formOptions.nationalityLabels.60',
        'defaultMessage': 'Danish'
    },
    61: {
        'id': 'formOptions.nationalityLabels.61',
        'defaultMessage': 'Djibouti'
    },
    62: {
        'id': 'formOptions.nationalityLabels.62',
        'defaultMessage': 'Dominican'
    },
    63: {
        'id': 'formOptions.nationalityLabels.63',
        'defaultMessage': 'Dominican Republic'
    },
    64: {
        'id': 'formOptions.nationalityLabels.64',
        'defaultMessage': 'DR Congo'
    },
    65: {
        'id': 'formOptions.nationalityLabels.65',
        'defaultMessage': 'Dutch'
    },
    66: {
        'id': 'formOptions.nationalityLabels.66',
        'defaultMessage': 'Ecuadorian'
    },
    67: {
        'id': 'formOptions.nationalityLabels.67',
        'defaultMessage': 'Egyptian'
    },
    68: {
        'id': 'formOptions.nationalityLabels.68',
        'defaultMessage': 'El Salvadorian'
    },
    69: {
        'id': 'formOptions.nationalityLabels.69',
        'defaultMessage': 'Equatorial Guinea'
    },
    70: {
        'id': 'formOptions.nationalityLabels.70',
        'defaultMessage': 'Eritrean'
    },
    71: {
        'id': 'formOptions.nationalityLabels.71',
        'defaultMessage': 'Estonian'
    },
    72: {
        'id': 'formOptions.nationalityLabels.72',
        'defaultMessage': 'Ethiopian'
    },
    73: {
        'id': 'formOptions.nationalityLabels.73',
        'defaultMessage': 'Falkland Islands'
    },
    74: {
        'id': 'formOptions.nationalityLabels.74',
        'defaultMessage': 'Faroe Islands'
    },
    75: {
        'id': 'formOptions.nationalityLabels.75',
        'defaultMessage': 'Fijian'
    },
    76: {
        'id': 'formOptions.nationalityLabels.76',
        'defaultMessage': 'Filipino'
    },
    77: {
        'id': 'formOptions.nationalityLabels.77',
        'defaultMessage': 'Finnish'
    },
    78: {
        'id': 'formOptions.nationalityLabels.78',
        'defaultMessage': 'French'
    },
    79: {
        'id': 'formOptions.nationalityLabels.79',
        'defaultMessage': 'French Guiana'
    },
    80: {
        'id': 'formOptions.nationalityLabels.80',
        'defaultMessage': 'French Polynesia'
    },
    81: {
        'id': 'formOptions.nationalityLabels.81',
        'defaultMessage': 'Gabonese'
    },
    82: {
        'id': 'formOptions.nationalityLabels.82',
        'defaultMessage': 'Gambian'
    },
    83: {
        'id': 'formOptions.nationalityLabels.83',
        'defaultMessage': 'Georgian'
    },
    84: {
        'id': 'formOptions.nationalityLabels.84',
        'defaultMessage': 'German'
    },
    85: {
        'id': 'formOptions.nationalityLabels.85',
        'defaultMessage': 'Ghanan'
    },
    86: {
        'id': 'formOptions.nationalityLabels.86',
        'defaultMessage': 'Gibraltar'
    },
    87: {
        'id': 'formOptions.nationalityLabels.87',
        'defaultMessage': 'Greek'
    },
    88: {
        'id': 'formOptions.nationalityLabels.88',
        'defaultMessage': 'Greenland'
    },
    89: {
        'id': 'formOptions.nationalityLabels.89',
        'defaultMessage': 'Grenada'
    },
    90: {
        'id': 'formOptions.nationalityLabels.90',
        'defaultMessage': 'Guadaloupe'
    },
    91: {
        'id': 'formOptions.nationalityLabels.91',
        'defaultMessage': 'Guam'
    },
    92: {
        'id': 'formOptions.nationalityLabels.92',
        'defaultMessage': 'Guatemalan'
    },
    93: {
        'id': 'formOptions.nationalityLabels.93',
        'defaultMessage': 'Guinea'
    },
    94: {
        'id': 'formOptions.nationalityLabels.94',
        'defaultMessage': 'Guinea-Bissau'
    },
    95: {
        'id': 'formOptions.nationalityLabels.95',
        'defaultMessage': 'Guyanese'
    },
    96: {
        'id': 'formOptions.nationalityLabels.96',
        'defaultMessage': 'Haitian'
    },
    97: {
        'id': 'formOptions.nationalityLabels.97',
        'defaultMessage': 'Honduran'
    },
    98: {
        'id': 'formOptions.nationalityLabels.98',
        'defaultMessage': 'Hong Kong'
    },
    99: {
        'id': 'formOptions.nationalityLabels.99',
        'defaultMessage': 'Hungarian'
    },
    100: {
        'id': 'formOptions.nationalityLabels.100',
        'defaultMessage': 'Icelandic'
    },
    101: {
        'id': 'formOptions.nationalityLabels.101',
        'defaultMessage': 'Indian'
    },
    102: {
        'id': 'formOptions.nationalityLabels.102',
        'defaultMessage': 'Indonesian'
    },
    103: {
        'id': 'formOptions.nationalityLabels.103',
        'defaultMessage': 'Iranian'
    },
    104: {
        'id': 'formOptions.nationalityLabels.104',
        'defaultMessage': 'Iraqi'
    },
    105: {
        'id': 'formOptions.nationalityLabels.105',
        'defaultMessage': 'Irish'
    },
    106: {
        'id': 'formOptions.nationalityLabels.106',
        'defaultMessage': 'Israeli'
    },
    107: {
        'id': 'formOptions.nationalityLabels.107',
        'defaultMessage': 'Italian'
    },
    108: {
        'id': 'formOptions.nationalityLabels.108',
        'defaultMessage': 'Ivory Coast'
    },
    109: {
        'id': 'formOptions.nationalityLabels.109',
        'defaultMessage': 'Jamaican'
    },
    110: {
        'id': 'formOptions.nationalityLabels.110',
        'defaultMessage': 'Japanese'
    },
    111: {
        'id': 'formOptions.nationalityLabels.111',
        'defaultMessage': 'Jordanian'
    },
    112: {
        'id': 'formOptions.nationalityLabels.112',
        'defaultMessage': 'Kazak'
    },
    113: {
        'id': 'formOptions.nationalityLabels.113',
        'defaultMessage': 'Kenyan'
    },
    114: {
        'id': 'formOptions.nationalityLabels.114',
        'defaultMessage': 'Kiribati'
    },
    115: {
        'id': 'formOptions.nationalityLabels.115',
        'defaultMessage': 'Kuwaiti'
    },
    116: {
        'id': 'formOptions.nationalityLabels.116',
        'defaultMessage': 'Kyrgyz'
    },
    117: {
        'id': 'formOptions.nationalityLabels.117',
        'defaultMessage': 'Laotian'
    },
    118: {
        'id': 'formOptions.nationalityLabels.118',
        'defaultMessage': 'Latvian'
    },
    119: {
        'id': 'formOptions.nationalityLabels.119',
        'defaultMessage': 'Lebanese'
    },
    120: {
        'id': 'formOptions.nationalityLabels.120',
        'defaultMessage': 'Lesotho'
    },
    121: {
        'id': 'formOptions.nationalityLabels.121',
        'defaultMessage': 'Liberian'
    },
    122: {
        'id': 'formOptions.nationalityLabels.122',
        'defaultMessage': 'Libyan'
    },
    123: {
        'id': 'formOptions.nationalityLabels.123',
        'defaultMessage': 'Liechtenstein'
    },
    124: {
        'id': 'formOptions.nationalityLabels.124',
        'defaultMessage': 'Lithuanian'
    },
    125: {
        'id': 'formOptions.nationalityLabels.125',
        'defaultMessage': 'Luxembourg'
    },
    126: {
        'id': 'formOptions.nationalityLabels.126',
        'defaultMessage': 'Macau'
    },
    127: {
        'id': 'formOptions.nationalityLabels.127',
        'defaultMessage': 'Macedonian'
    },
    128: {
        'id': 'formOptions.nationalityLabels.128',
        'defaultMessage': 'Madagascan'
    },
    129: {
        'id': 'formOptions.nationalityLabels.129',
        'defaultMessage': 'Malawi'
    },
    130: {
        'id': 'formOptions.nationalityLabels.130',
        'defaultMessage': 'Malaysian'
    },
    131: {
        'id': 'formOptions.nationalityLabels.131',
        'defaultMessage': 'Maldives'
    },
    132: {
        'id': 'formOptions.nationalityLabels.132',
        'defaultMessage': 'Mali'
    },
    133: {
        'id': 'formOptions.nationalityLabels.133',
        'defaultMessage': 'Maltese'
    },
    134: {
        'id': 'formOptions.nationalityLabels.134',
        'defaultMessage': 'Mariana Islands'
    },
    135: {
        'id': 'formOptions.nationalityLabels.135',
        'defaultMessage': 'Marshall Islands'
    },
    136: {
        'id': 'formOptions.nationalityLabels.136',
        'defaultMessage': 'Martinique'
    },
    137: {
        'id': 'formOptions.nationalityLabels.137',
        'defaultMessage': 'Mauritanian'
    },
    138: {
        'id': 'formOptions.nationalityLabels.138',
        'defaultMessage': 'Mauritian'
    },
    139: {
        'id': 'formOptions.nationalityLabels.139',
        'defaultMessage': 'Mexican'
    },
    140: {
        'id': 'formOptions.nationalityLabels.140',
        'defaultMessage': 'Micronesian'
    },
    141: {
        'id': 'formOptions.nationalityLabels.141',
        'defaultMessage': 'Moldova'
    },
    142: {
        'id': 'formOptions.nationalityLabels.142',
        'defaultMessage': 'Monaco'
    },
    143: {
        'id': 'formOptions.nationalityLabels.143',
        'defaultMessage': 'Mongolian'
    },
    144: {
        'id': 'formOptions.nationalityLabels.144',
        'defaultMessage': 'Montenegran'
    },
    145: {
        'id': 'formOptions.nationalityLabels.145',
        'defaultMessage': 'Montserratian'
    },
    146: {
        'id': 'formOptions.nationalityLabels.146',
        'defaultMessage': 'Moroccan'
    },
    147: {
        'id': 'formOptions.nationalityLabels.147',
        'defaultMessage': 'Mozambique'
    },
    148: {
        'id': 'formOptions.nationalityLabels.148',
        'defaultMessage': 'Myanmar'
    },
    149: {
        'id': 'formOptions.nationalityLabels.149',
        'defaultMessage': 'Namibian'
    },
    150: {
        'id': 'formOptions.nationalityLabels.150',
        'defaultMessage': 'Nauru'
    },
    151: {
        'id': 'formOptions.nationalityLabels.151',
        'defaultMessage': 'Nepalese'
    },
    152: {
        'id': 'formOptions.nationalityLabels.152',
        'defaultMessage': 'Netherlands Antilles'
    },
    153: {
        'id': 'formOptions.nationalityLabels.153',
        'defaultMessage': 'New Caledonian'
    },
    154: {
        'id': 'formOptions.nationalityLabels.154',
        'defaultMessage': 'New Zealand'
    },
    155: {
        'id': 'formOptions.nationalityLabels.155',
        'defaultMessage': 'Nicaraguan'
    },
    156: {
        'id': 'formOptions.nationalityLabels.156',
        'defaultMessage': 'Niger'
    },
    157: {
        'id': 'formOptions.nationalityLabels.157',
        'defaultMessage': 'Nigerian'
    },
    158: {
        'id': 'formOptions.nationalityLabels.158',
        'defaultMessage': 'Niue'
    },
    159: {
        'id': 'formOptions.nationalityLabels.159',
        'defaultMessage': 'Norfolk Island'
    },
    160: {
        'id': 'formOptions.nationalityLabels.160',
        'defaultMessage': 'North Korean'
    },
    161: {
        'id': 'formOptions.nationalityLabels.161',
        'defaultMessage': 'Norwegian'
    },
    162: {
        'id': 'formOptions.nationalityLabels.162',
        'defaultMessage': 'Omani'
    },
    163: {
        'id': 'formOptions.nationalityLabels.163',
        'defaultMessage': 'Pakistani'
    },
    164: {
        'id': 'formOptions.nationalityLabels.164',
        'defaultMessage': 'Palau'
    },
    165: {
        'id': 'formOptions.nationalityLabels.165',
        'defaultMessage': 'Panamanian'
    },
    166: {
        'id': 'formOptions.nationalityLabels.166',
        'defaultMessage': 'Papua New Guinea'
    },
    167: {
        'id': 'formOptions.nationalityLabels.167',
        'defaultMessage': 'Paraguayan'
    },
    168: {
        'id': 'formOptions.nationalityLabels.168',
        'defaultMessage': 'Peruvian'
    },
    169: {
        'id': 'formOptions.nationalityLabels.169',
        'defaultMessage': 'Pitcairn Islands'
    },
    170: {
        'id': 'formOptions.nationalityLabels.170',
        'defaultMessage': 'Polish'
    },
    171: {
        'id': 'formOptions.nationalityLabels.171',
        'defaultMessage': 'Portuguese'
    },
    172: {
        'id': 'formOptions.nationalityLabels.172',
        'defaultMessage': 'Puerto Rican'
    },
    173: {
        'id': 'formOptions.nationalityLabels.173',
        'defaultMessage': 'Qatari'
    },
    174: {
        'id': 'formOptions.nationalityLabels.174',
        'defaultMessage': 'Reunion'
    },
    175: {
        'id': 'formOptions.nationalityLabels.175',
        'defaultMessage': 'Romanian'
    },
    176: {
        'id': 'formOptions.nationalityLabels.176',
        'defaultMessage': 'Russian'
    },
    177: {
        'id': 'formOptions.nationalityLabels.177',
        'defaultMessage': 'Rwandan'
    },
    178: {
        'id': 'formOptions.nationalityLabels.178',
        'defaultMessage': 'San Marino'
    },
    179: {
        'id': 'formOptions.nationalityLabels.179',
        'defaultMessage': 'Sao Tome - Principe'
    },
    180: {
        'id': 'formOptions.nationalityLabels.180',
        'defaultMessage': 'Saudi Arabian'
    },
    181: {
        'id': 'formOptions.nationalityLabels.181',
        'defaultMessage': 'Senegalese'
    },
    182: {
        'id': 'formOptions.nationalityLabels.182',
        'defaultMessage': 'Serbian'
    },
    183: {
        'id': 'formOptions.nationalityLabels.183',
        'defaultMessage': 'Seychelles'
    },
    184: {
        'id': 'formOptions.nationalityLabels.184',
        'defaultMessage': 'Sierra Leone'
    },
    185: {
        'id': 'formOptions.nationalityLabels.185',
        'defaultMessage': 'Singaporean'
    },
    186: {
        'id': 'formOptions.nationalityLabels.186',
        'defaultMessage': 'Slovak'
    },
    187: {
        'id': 'formOptions.nationalityLabels.187',
        'defaultMessage': 'Slovenian'
    },
    188: {
        'id': 'formOptions.nationalityLabels.188',
        'defaultMessage': 'Solomon Islands'
    },
    189: {
        'id': 'formOptions.nationalityLabels.189',
        'defaultMessage': 'Somalian'
    },
    190: {
        'id': 'formOptions.nationalityLabels.190',
        'defaultMessage': 'South African'
    },
    191: {
        'id': 'formOptions.nationalityLabels.191',
        'defaultMessage': 'South Korean'
    },
    192: {
        'id': 'formOptions.nationalityLabels.192',
        'defaultMessage': 'Spanish'
    },
    193: {
        'id': 'formOptions.nationalityLabels.193',
        'defaultMessage': 'Sri Lankan'
    },
    194: {
        'id': 'formOptions.nationalityLabels.194',
        'defaultMessage': 'St Helenian'
    },
    195: {
        'id': 'formOptions.nationalityLabels.195',
        'defaultMessage': 'St Kitts and Nevis'
    },
    196: {
        'id': 'formOptions.nationalityLabels.196',
        'defaultMessage': 'St Lucia'
    },
    197: {
        'id': 'formOptions.nationalityLabels.197',
        'defaultMessage': 'St Maarten'
    },
    198: {
        'id': 'formOptions.nationalityLabels.198',
        'defaultMessage': 'St Pierre - Miquelon'
    },
    199: {
        'id': 'formOptions.nationalityLabels.199',
        'defaultMessage': 'Sudanese'
    },
    200: {
        'id': 'formOptions.nationalityLabels.200',
        'defaultMessage': 'Suriname'
    },
    201: {
        'id': 'formOptions.nationalityLabels.201',
        'defaultMessage': 'Svalbard'
    },
    202: {
        'id': 'formOptions.nationalityLabels.202',
        'defaultMessage': 'Swaziland'
    },
    203: {
        'id': 'formOptions.nationalityLabels.203',
        'defaultMessage': 'Swedish'
    },
    204: {
        'id': 'formOptions.nationalityLabels.204',
        'defaultMessage': 'Swiss'
    },
    205: {
        'id': 'formOptions.nationalityLabels.205',
        'defaultMessage': 'Syrian'
    },
    206: {
        'id': 'formOptions.nationalityLabels.206',
        'defaultMessage': 'Tadjik'
    },
    207: {
        'id': 'formOptions.nationalityLabels.207',
        'defaultMessage': 'Taiwanese'
    },
    208: {
        'id': 'formOptions.nationalityLabels.208',
        'defaultMessage': 'Tanzanian'
    },
    209: {
        'id': 'formOptions.nationalityLabels.209',
        'defaultMessage': 'Thai'
    },
    210: {
        'id': 'formOptions.nationalityLabels.210',
        'defaultMessage': 'Timorese'
    },
    211: {
        'id': 'formOptions.nationalityLabels.211',
        'defaultMessage': 'Togo'
    },
    212: {
        'id': 'formOptions.nationalityLabels.212',
        'defaultMessage': 'Tongan'
    },
    213: {
        'id': 'formOptions.nationalityLabels.213',
        'defaultMessage': 'Trinidadian'
    },
    214: {
        'id': 'formOptions.nationalityLabels.214',
        'defaultMessage': 'Tunisian'
    },
    215: {
        'id': 'formOptions.nationalityLabels.215',
        'defaultMessage': 'Turkish'
    },
    216: {
        'id': 'formOptions.nationalityLabels.216',
        'defaultMessage': 'Turkmen'
    },
    217: {
        'id': 'formOptions.nationalityLabels.217',
        'defaultMessage': 'Turks and Caicos'
    },
    218: {
        'id': 'formOptions.nationalityLabels.218',
        'defaultMessage': 'Tuvalu'
    },
    219: {
        'id': 'formOptions.nationalityLabels.219',
        'defaultMessage': 'Ugandan'
    },
    220: {
        'id': 'formOptions.nationalityLabels.220',
        'defaultMessage': 'Ukrainian'
    },
    221: {
        'id': 'formOptions.nationalityLabels.221',
        'defaultMessage': 'United Arab Emirates'
    },
    222: {
        'id': 'formOptions.nationalityLabels.222',
        'defaultMessage': 'Uruguayan'
    },
    223: {
        'id': 'formOptions.nationalityLabels.223',
        'defaultMessage': 'American'
    },
    224: {
        'id': 'formOptions.nationalityLabels.224',
        'defaultMessage': 'US Virgin Islands'
    },
    225: {
        'id': 'formOptions.nationalityLabels.225',
        'defaultMessage': 'Uzbek'
    },
    226: {
        'id': 'formOptions.nationalityLabels.226',
        'defaultMessage': 'Vanuatu'
    },
    227: {
        'id': 'formOptions.nationalityLabels.227',
        'defaultMessage': 'Vatican'
    },
    228: {
        'id': 'formOptions.nationalityLabels.228',
        'defaultMessage': 'Venezuelan'
    },
    229: {
        'id': 'formOptions.nationalityLabels.229',
        'defaultMessage': 'Vietnamese'
    },
    230: {
        'id': 'formOptions.nationalityLabels.230',
        'defaultMessage': 'Vincentian'
    },
    231: {
        'id': 'formOptions.nationalityLabels.231',
        'defaultMessage': 'Wake Island'
    },
    232: {
        'id': 'formOptions.nationalityLabels.232',
        'defaultMessage': 'Wallis and Futuna'
    },
    233: {
        'id': 'formOptions.nationalityLabels.233',
        'defaultMessage': 'Western Samoa'
    },
    234: {
        'id': 'formOptions.nationalityLabels.234',
        'defaultMessage': 'Yememi'
    },
    235: {
        'id': 'formOptions.nationalityLabels.235',
        'defaultMessage': 'Yugoslavian'
    },
    236: {
        'id': 'formOptions.nationalityLabels.236',
        'defaultMessage': 'Zambian'
    },
    237: {
        'id': 'formOptions.nationalityLabels.237',
        'defaultMessage': 'Zimbabwean'
    },
    238: {
        'id': 'formOptions.nationalityLabels.238',
        'defaultMessage': 'Palestinian'
    },
    239: {
        'id': 'formOptions.nationalityLabels.239',
        'defaultMessage': 'Kosovar'
    }
});

exports.default = nationalityLabels;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOptions/nationality/nationalityLabels.js
// module id = 1377
// module chunks = 0